import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ExpandArrow } from "./assets/icons/ExpandArrow.js";
import "react/jsx-runtime";
const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  margin: "8px 0",
  minHeight: "40px"
}));
const ExpandArrowIcon = styled(ExpandArrow, {
  shouldForwardProp: (props) => props !== "isExpanded"
})(({ isExpanded }) => ({
  ...isExpanded && {
    transform: "rotate(180deg)"
  }
}));
export {
  ExpandArrowIcon,
  StyledTypography
};
